var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"centerall"},[_c('img',{staticClass:"background-img",attrs:{"src":require("@/assets/productIntroduction/videoRecorder1.webp"),"alt":"背景图"}})]),_c('div',{staticClass:"centerall1"},[_c('img',{staticClass:"background-img",attrs:{"src":require("@/assets/productIntroduction/videoRecorder2.webp"),"alt":"背景图"}})])])
}]

export { render, staticRenderFns }